import React from 'react';

const AnniversarySection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden py-20">
      {/* Background gradient with yellow glow */}
      <div className="absolute inset-0 bg-gradient-to-b from-black via-yellow-900/20 to-black"></div>
      
      {/* Animated radial gradient spotlight */}
      <div className="absolute inset-0">
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[1000px] bg-yellow-500/30 rounded-full blur-3xl animate-pulse"></div>
      </div>

      {/* Floating particles */}
      <div className="absolute inset-0 overflow-hidden">
        {[...Array(20)].map((_, i) => (
          <div
            key={i}
            className="absolute w-2 h-2 bg-yellow-500/30 rounded-full animate-float"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              animationDuration: `${5 + Math.random() * 10}s`
            }}
          ></div>
        ))}
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="flex flex-col items-center justify-center">
          {/* 3D Number 7 with realistic 3D effect */}
          <div className="perspective-1000 mb-8">
            <div className="flex items-center justify-center animate-fade-in-up">
              <div className="relative transform hover:scale-110 transition-all duration-700 animate-float-slow">
                {/* Main number with gradient */}
                <div 
                  className="text-[250px] md:text-[350px] font-bold relative z-10 bg-gradient-to-b from-white via-gray-200 to-gray-400 bg-clip-text text-transparent" 
                  style={{ 
                    fontFamily: 'Arial, sans-serif'
                  }}
                >
                  7
                </div>
                
                {/* 3D depth layers */}
                <div 
                  className="absolute inset-0 text-[250px] md:text-[350px] font-bold text-gray-700" 
                  style={{ 
                    transform: 'translate(12px, 12px)', 
                    zIndex: 0,
                    fontFamily: 'Arial, sans-serif'
                  }}
                >
                  7
                </div>
                <div 
                  className="absolute inset-0 text-[250px] md:text-[350px] font-bold text-gray-600" 
                  style={{ 
                    transform: 'translate(8px, 8px)', 
                    zIndex: 1,
                    fontFamily: 'Arial, sans-serif'
                  }}
                >
                  7
                </div>
                <div 
                  className="absolute inset-0 text-[250px] md:text-[350px] font-bold text-gray-500" 
                  style={{ 
                    transform: 'translate(4px, 4px)', 
                    zIndex: 2,
                    fontFamily: 'Arial, sans-serif'
                  }}
                >
                  7
                </div>
                
                {/* Shine effect */}
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent animate-shine" style={{ transform: 'skewX(-20deg)' }}></div>
              </div>
            </div>
          </div>

          {/* Text content below the number */}
          <div className="text-center max-w-4xl animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
            <h2 className="text-4xl md:text-6xl font-bold mb-6">
              <span className="text-yellow-500">
                years of empowering traders,
              </span>
            </h2>
            <h3 className="text-3xl md:text-5xl font-bold mb-8">
              <span className="bg-gradient-to-r from-white via-gray-200 to-gray-400 bg-clip-text text-transparent">
                and it's just a beginning.
              </span>
            </h3>
            
            <div className="mt-12 p-8 bg-gradient-to-r from-yellow-500/10 to-amber-500/10 rounded-2xl border border-yellow-500/20 backdrop-blur-sm">
              <h4 className="text-2xl md:text-3xl font-bold text-white mb-4">
                PreciseFx — Your Trusted Automated Trading Partner
              </h4>
              <p className="text-lg md:text-xl text-gray-300">
                We provide a secure and intelligent trading system, powered by 7 years of experience, built for both beginners and professionals.
              </p>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0px) translateX(0px);
            opacity: 0;
          }
          50% {
            transform: translateY(-100px) translateX(50px);
            opacity: 1;
          }
        }
        
        @keyframes float-slow {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-20px);
          }
        }
        
        @keyframes shine {
          0% {
            left: -100%;
          }
          100% {
            left: 200%;
          }
        }
        
        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes pulse-slow {
          0%, 100% {
            opacity: 0.7;
          }
          50% {
            opacity: 1;
          }
        }
        
        .animate-float {
          animation: float linear infinite;
        }
        
        .animate-float-slow {
          animation: float-slow 3s ease-in-out infinite;
        }
        
        .animate-shine {
          animation: shine 3s ease-in-out infinite;
        }
        
        .animate-fade-in-up {
          animation: fade-in-up 1s ease-out;
        }
        
        .animate-pulse-slow {
          animation: pulse-slow 2s ease-in-out infinite;
        }
      `}</style>
    </section>
  );
};

export default AnniversarySection;
